<template>
  <div
    v-if="shouldShow"
    class="text-center py-[8px]"
  >
    <div
      v-if="fetcher && fetcher.isLoading"
      class="flex items-center justify-center gap-[8px] text-sm text-gray-600"
    >
      <b-spinner
        small
        variant="primary"
      />
      <span>Memuat data...</span>
    </div>

    <div
      v-else-if="fetcher && fetcher.error"
      class="flex items-center justify-center gap-[8px] text-sm text-red-600"
      :class="{ 'flex-col': !isFooter }"
    >
      <span>{{ defaultErrorMessage }}</span>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="$emit('retry')"
      >
        Coba Lagi
      </b-button>
    </div>

    <span v-else-if="!isFooter">{{ emptyText }}</span>
  </div>
</template>

<script>
/**
 * Renders state indicators (loading spinner, error message with retry button, or empty text)
 * for paginated tables using a paginated fetcher instance.
 */
export default {
  name: 'TablePaginationState',
  props: {
    /** Paginated fetcher instance containing loading, error, and data reactive properties. */
    fetcher: {
      type: Object,
      default: null,
    },
    /** Indicates if the component is being rendered inside a table footer for infinite scroll. */
    isFooter: {
      type: Boolean,
      default: false,
    },
    /** Text displayed when no data is available. */
    emptyText: {
      type: String,
      default: 'Tidak ada data yang ditampilkan.',
    },
    /** Custom error message string. */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasData() {
      return Boolean(this.fetcher && this.fetcher.data && this.fetcher.data.length > 0)
    },
    shouldShow() {
      if (this.isFooter) {
        return this.hasData && (this.fetcher.isLoading || Boolean(this.fetcher.error))
      }
      return true
    },
    defaultErrorMessage() {
      if (this.errorMessage) return this.errorMessage
      return this.isFooter ? 'Gagal memuat data tambahan.' : 'Gagal memuat data. Silakan coba lagi.'
    },
  },
}
</script>
